<template>
    <div class="body">
        <v-toolbar flat color="white">
            <v-toolbar-title></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark @click.native.stop="dialog = true">New</v-btn>
        </v-toolbar>

        <v-flex xs8 class="xs-center">
        </v-flex>
        <v-dialog v-model="dialog" max-width="500">
            <v-card>
                <div>
                    <v-container>
                        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                            <p class="headline">Extra Hours:</p>
                            <v-textarea
                                    :rules="requiredRules"
                                    v-model="model.reason"
                                    placeholder="reason"
                                    style="padding: 0 10px"
                                    rows="2"
                            ></v-textarea>
                            <div>
                                <choose-date v-model="model.date" label="Date"/>
                                <choose-time v-model="model.from" label="Start Time"/>
                                <choose-time v-model="model.to" label="End Time"/>
                            </div>
                            <v-btn color="primary" @click="submit">Submit</v-btn>
                        </v-form>
                    </v-container>
                </div>
            </v-card>
        </v-dialog>

        <DataTable
                ref="datatable"
                :url="url"
                :formatter="formatter"
                :fields-hidden-main="['updated_at','created_at','user_id','handler_id','first_name']"
                :fields-hidden-edit="['updated_at','created_at','user_id','handler_id','first_name', 'id', 'date', 'from','to','auto_generated','handler','approved']"
                :fields-extra-main="fieldsExtraMain"
                :disableSearch="true"
                :enableAdd="false"
                :enable-delete="false"
                :titles="titles"
                title="ExtraHours"
        />
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import ChooseTime from "@/components/wasilni/input/ChooseTime";

    export default {
        name: "MyExtraHours",
        title: 'MyExtraHours',
        components: {DataTable, ChooseDate, ChooseTime},
        data() {
            return {
                dialog: false,
                snackbar: false,
                message: "",
                valid: true,
                lazy: false,
                loading: false,
                url: this.api.ACTIONS.EXTRA_HOURS,
                requiredRules: [(v) => !!v || "الحقل مطلوب"],
                model: {
                    reason: "",
                    from: "",
                    to: "",
                    date: "",
                },
            }
        },
        methods: {
            submit() {
                this.loading = true;
                this.axios
                    .post(
                        this.api.ACTIONS.EXTRA_HOURS,
                        this.model
                    )
                    .then((res) => {
                        window.getApp.$emit("SHOW_TOAST", "Saved!", "green");
                        this.dialog = false;
                        this.$refs.datatable.addItemToTable(Object.assign(res.data.data), false);
                    })
                    .catch((err) => {
                        let message = '';
                        try {
                            message = err.response.data.message;
                        } catch (e) {
                            message = 'failed, Server error';
                        }
                        window.getApp.$emit('SHOW_TOAST', message, 'red');
                    })
                    .finally(() => (this.loading = false));
            }
        },
        computed: {
            titles() {
                return {
                    id: '#',
                    from: 'From',
                    to: 'To',
                    reason: 'Reason',
                    approved: 'Status',
                    handler: 'Handler'
                }
            },
            formatter() {
                return {
                    approved: (value) => {
                        if (value == null) return 'Pending';
                        else if (value == 1) return 'Approved';
                        else return 'Rejected';
                    },
                    handler: (value) => {
                        return value ? value.first_name + ' ' + value.last_name : ' '
                    }
                }
            },
            fieldsExtraMain() {
                return {
                    handler: (value) => {
                        return value.first_name ? value.first_name + ' ' + value.last_name : ' '
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>
